/**
 * Transforma a data de exercício para o formato `Aaa 000`
 *
 * @param exercicio Data de exercício no formato `mmm yyyy`
 * @returns Data de exercício no formato `Aaa 000`,
 *   retorna o próprio parâmetro `exercicio` caso inválido
 */
export function formatarExercicio(exercicio: string) {
  const regexExercicio = /^\w{3} \d{4}$/;

  if (!regexExercicio.test(exercicio)) {
    return exercicio;
  }

  // Função faz apenas o captalize da string de exercicio DEZ 2024 > Dez 2024
  const [mes, ano] = exercicio.split(' ');
  const mesFormatado = mes.charAt(0).toUpperCase() + mes.slice(1).toLowerCase();

  return `${mesFormatado} ${ano}`;
}
